// userMentionNode.js
// User mention inline node definition

/**
 * User mention inline node
 * Renders as @username with rich user information
 */
export const userMentionNode = {
    inline: true,
    atom: true,
    group: "inline",
    draggable: true,
    selectable: true,
    attrs: {
        id: {},                       // Required: user ID
        label: {},                    // Required: display text (@name)
        name: {default: null},        // Full name
        email: {default: null},       // Email address
        position: {default: null},    // Job title
        headshot: {default: null},    // Avatar URL
    },
    parseDOM: [{
        tag: "span[data-mention-id]",
        getAttrs(dom) {
            return {
                id: dom.getAttribute("data-mention-id"),
                label: dom.getAttribute("data-mention-label"),
                name: dom.getAttribute("data-mention-name"),
                email: dom.getAttribute("data-mention-email"),
                position: dom.getAttribute("data-mention-position"),
                headshot: dom.getAttribute("data-mention-headshot"),
            };
        }
    }],
    toDOM(node) {
        const attrs = {
            class: "user-mention",
            "data-mention-id": node.attrs.id,
            "data-mention-label": node.attrs.label,
            contenteditable: "false",
            spellcheck: "false",
        };

        if (node.attrs.name) attrs["data-mention-name"] = node.attrs.name;
        if (node.attrs.email) attrs["data-mention-email"] = node.attrs.email;
        if (node.attrs.position) attrs["data-mention-position"] = node.attrs.position;
        if (node.attrs.headshot) attrs["data-mention-headshot"] = node.attrs.headshot;

        attrs["aria-label"] = `User mention: ${node.attrs.label || node.attrs.name || 'Unknown'}`;

        return ["span", attrs, `@${node.attrs.label}`];
    }
};

